module.exports = __webpack_public_path__ + "static/img/minicon2.b5d29c51.png";